module.exports = __webpack_public_path__ + "static/media/check-symbol.06277842.svg";